import { Container } from "./styles";
import githubIcon from "../../assets/github.svg"
import ScrollAnimation from "react-animate-on-scroll";


export function Project() {
  return (
    <Container id="project">
      <h2>My Projects</h2>
      <div className="projects">

        <ScrollAnimation animateIn="flipInX">
          <div className="project featured">
            <div className="featured-badge">🚀 Featured POC</div>
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#667eea" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <span className="private-badge">Private</span>
              </div>
            </header>
            <div className="body">
              <h3>POC: Insurance Claim Processing</h3>
              <p>
                Built a modular, Agentic AI, multi-agent system for end-to-end insurance claim automation from FNOL to payment. 
                Integrated agents for customer verification, policy validation, damage assessment, compliance, and communication, 
                orchestrated using AutoGen. Designed for dynamic cross-domain claims (auto, home, health) with improved accuracy 
                and reduced manual review time.
              </p>
              <div className="role-section">
                <strong>Role:</strong> Designed multi-agent AutoGen system with SelectorGroupChat, integrated Socket.IO/WebSockets 
                for real-time agent log streaming, implemented Mistral OCR for image extraction, and built interactive UI in Next.js.
              </div>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Next.js</li>
                <li>React.js</li>
                <li>Python</li>
                <li>AutoGen 0.4</li>
                <li>WebSocket</li>
                <li>Azure OpenAI</li>
                <li>Mistral OCR</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project featured">
            <div className="featured-badge">🚀 Featured POC</div>
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#667eea" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <span className="private-badge">Private</span>
              </div>
            </header>
            <div className="body">
              <h3>POC: Agentic Warehouse Management</h3>
              <p>
                Built an AI-powered, multi-agent warehouse management system to automate and optimize supply chain operations 
                using Agentic AI with Autogen. Integrated intelligent agents for inventory tracking, order fulfillment, 
                supplier coordination, and logistics optimization. Enables real-time decision-making and adaptive workflows.
              </p>
              <div className="role-section">
                <strong>Role:</strong> Designed agentic workflows using Autogen and AgentChat, implemented real-time visualization 
                dashboards for warehouse managers, integrated PostgreSQL for data management, and deployed on Azure with CI/CD via GitHub Actions.
              </div>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Python</li>
                <li>Autogen</li>
                <li>AgentChat</li>
                <li>PostgreSQL</li>
                <li>Next.js</li>
                <li>React.js</li>
                <li>Azure OpenAI</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project featured">
            <div className="featured-badge">🤖 AI Project</div>
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#667eea" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <span className="private-badge">Private</span>
              </div>
            </header>
            <div className="body">
              <h3>AI Interview Prep Application</h3>
              <p>
                An intelligent interview preparation platform powered by AI that helps candidates practice and improve 
                their interview skills. Features include AI-generated questions based on job roles, real-time feedback 
                on responses, mock interview sessions with AI interviewer, and personalized improvement suggestions.
              </p>
              <div className="role-section">
                <strong>Role:</strong> Full-stack development with AI integration for question generation and response analysis, 
                built conversational AI interface, and implemented progress tracking dashboard.
              </div>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React.js</li>
                <li>Python</li>
                <li>LangChain</li>
                <li>Azure OpenAI</li>
                <li>FastAPI</li>
                <li>MongoDB</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

      </div>

      <ScrollAnimation animateIn="fadeInUp">
        <div className="more-projects">
          <div className="more-projects-content">
            <span className="count">50+</span>
            <span className="text">More Projects</span>
            <p>Including web applications, AI/ML solutions, open-source contributions, community tools, and enterprise systems.</p>
            <a href="https://github.com/KirtiKamal" target="_blank" rel="noreferrer" className="view-all-btn">
              <img src={githubIcon} alt="GitHub" />
              View All on GitHub
            </a>
          </div>
        </div>
      </ScrollAnimation>
    </Container>
  );
}